export default __webpack_public_path__ + "static/media/ISSO CLASS-7 EXAM PATTERN 2025.b196a0ab.pdf";